import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const navItems = [
    { label: 'Home', href: '/#home', isHash: true },
    { label: 'About', href: '/#about', isHash: true },
    { label: 'Projects', href: '/projects', isHash: false },
    { label: 'Team', href: '/#team', isHash: true },
    { label: 'Contact', href: '/#contact', isHash: true },
    { label: 'FAQ', href: '/#faq', isHash: true },
    { label: 'Warehouse', href: '/warehouse', isHash: false },
    { label: 'Hotel', href: '/hotel', isHash: false },
    { label: 'Farms', href: '/farms', isHash: false }
];

const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -80; // Adjust this value based on your header height
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
}

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="px-4 sm:px-6 lg:px-8 py-2 lg:py-4 bg-[lightblue] shadow-sm w-screen">
            <div className="flex items-center justify-between max-w-7xl mx-auto w-full overflow-hidden">
                {/* Logo and Company Name */}
                <HashLink to="/#home" className="flex items-center space-x-2">
                <div className="flex items-center space-x-2 flex-shrink-0">
                    <img 
                        src="/logo2.png" 
                        alt="DariInvestments Logo" 
                        className="h-8 lg:h-10 w-auto" 
                    />
                    <div className="hidden sm:flex flex-col items-start">
                        <div className="flex items-center">
                            <div className="h-10 w-px bg-black mx-2"></div>
                            <div className="flex flex-col">
                                <span className="font-bold text-sm lg:text-xl text-black whitespace-nowrap">
                                    DARI
                                </span>
                                <span className="font-bold text-sm lg:text-xl text-black whitespace-nowrap">
                                    INVESTMENT
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                </HashLink>

                {/* Hamburger Menu Button */}
                <button
                    className="lg:hidden text-black z-50"
                    onClick={toggleMenu}
                >
                    {isMenuOpen ? (
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    ) : (
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    )}
                </button>

                {/* Navigation Menu */}
                <nav className={`
                    ${isMenuOpen ? 'translate-x-0' : '-translate-x-full'} 
                    lg:translate-x-0
                    fixed lg:relative 
                    top-0 lg:top-auto 
                    left-0 
                    h-screen lg:h-auto 
                    w-64 lg:w-auto 
                    bg-[lightblue] 
                    transition-transform duration-300 ease-in-out
                    z-40
                    lg:flex lg:items-center
                    lg:flex-grow
                    lg:justify-end
                `}>
                    <ul className="flex flex-col lg:flex-row list-none m-0 p-4 lg:p-0 lg:items-center space-y-4 lg:space-y-0">
                        {navItems.map(item => (
                            <li key={item.label} className="lg:mx-2">
                                {item.isHash ? (
                                    <HashLink
                                        smooth 
                                        to={item.href}
                                        scroll={scrollWithOffset}
                                        className="block no-underline text-black font-medium text-base sm:text-sm lg:text-base 
                                        hover:text-purple-600 transition-all duration-300 ease-out whitespace-nowrap py-2 lg:py-0
                                        hover:scale-110 hover:font-semibold hover:drop-shadow-[0_0_3px_rgba(0,0,0,0.3)]"
                                        onClick={() => setIsMenuOpen(false)}
                                    >
                                        {item.label}
                                    </HashLink>
                                ) : (
                                    <Link
                                        to={item.href}
                                        className="block no-underline text-black font-medium text-base sm:text-sm lg:text-base 
                                        hover:text-purple-600 transition-all duration-300 ease-out whitespace-nowrap py-2 lg:py-0
                                        hover:scale-110 hover:font-semibold hover:drop-shadow-[0_0_3px_rgba(0,0,0,0.3)]"
                                        onClick={() => setIsMenuOpen(false)}
                                    >
                                        {item.label}
                                    </Link>
                                )}
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;